
import {of as observableOf, throwError as observableThrowError,  Observable } from 'rxjs';

import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from '../logger-service/logger.service';
import { StorageService } from '../storage-service/storage.service';




@Injectable()
export class ApiService {

    private _protocol: string = window.location.protocol;
    private _baseApi: string = '/api/mgt/1.0';

    constructor(
        private _http: HttpClient,
        private _logger: LoggerService,
        private _storage: StorageService,
    ) { }

    public retrieveManifest(): Observable<any> {
        const manifestUrl = 'assets/manifest.webapp';
        this._logger.info('ApiService', 'Getting application manifest at: ' + manifestUrl);

        return this._http.get(manifestUrl).pipe(
            catchError(e => {
                this._logger.error('ApiService', 'ERROR getting application manifest : ' + e);
                return observableThrowError(e);
            }));
    }

    public retrieveModelStructure(option?: string): Observable<Object> {
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/model' + (option ? '/' + option : '');
        this._logger.info('ApiService', 'Getting model structure at: ' + url);

        return this._http.get(url).pipe(
            catchError(e => {
                this._logger.error('ApiService', 'ERROR getting model structure : ' + e);
                return observableThrowError(e);
            }));
    }
    

    public retrieveDictionnary(lang: string): Observable<Object> {
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/dictionnary/' + lang;
      //  this._logger.info('ApiService', 'Getting dictionnary <' + lang + '> at: ' + url);

        return this._http.get(url).pipe(
            map(response => response),
            catchError(e => {
                this._logger.error('ApiService', 'ERROR getting dictionnary : ' + e);
                return observableThrowError(e);
            }),);
    }

    public retrieveHelp(lang: string): Observable<string> {
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/help/' + lang;
        this._logger.info('ApiService', 'Getting help <' + lang + '> at: ' + url);

        return this._http.get(url, { responseType: 'text' }).pipe(
            catchError(e => {
                this._logger.error('ApiService', 'ERROR getting help : ' + e);
                return observableThrowError(e);
            }));
    }

    public retrieveErrors(lang: string): Observable<Object> {
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/error/' + lang;
        this._logger.info('ApiService', 'Getting error labels <' + lang + '> at: ' + url);

        return this._http.get(url).pipe(
            map(response => response),
            catchError(e => {
                this._logger.error('ApiService', 'ERROR getting error labels : ' + e);
                return observableThrowError(e);
            }),);
    }

    public retrieveObject(path: string, shouldLogError = true): Observable<Object> {
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/' + path;
        this._logger.info('ApiService', 'Getting an object at: ' + url);

//        this._logger.storeLogArray('Info', 'Getting an object at: ' + url);
        return this._http.get(url).pipe(
            map(response => response),
            catchError(e => {
                if (shouldLogError) {
                    this._logger.error('ApiService', 'ERROR getting an object : ' + e);
                    this._logger.storeLogArray('Error', 'ERROR getting an object : ' + e);
                }
                return observableThrowError(e);
            }),);
    }

public retrieveVersion(): Observable<Object>{
         let url =  this._protocol + '//' + this._storage.getHost() + this._baseApi + '/' + 'Node/';
        return this._http.get(url).pipe(
            map(response => response),
            catchError(e => {
                return observableOf();
            }),);
    }
    public putObject(path: string, objData: Object): Observable<Object> {
        this._logger.info('ApiService', 'Putting an object at: ' + path);
       // this._logger.storeLogArray('Info', 'Putting an object at: ' + path);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/' + path;

        return this._http.put(url, JSON.stringify(objData), { headers }).pipe(
            catchError(e => {
                this._logger.error('ApiService', 'ERROR putting an object : ' + e);
                return observableThrowError(e);
            }));
    }

    public postObject(path: string, objData: Object): Observable<Object> {
        this._logger.info('ApiService', 'Posting an object at: ' + path);

        //this._logger.storeLogArray('Info', 'Creating an object ' + objData['Directory_Number']);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/' + path;

        return this._http.post(url, JSON.stringify(objData), {  headers }).pipe(
            catchError(e => {
                this._logger.error('ApiService', 'ERROR posting an object : ' + e);
         //       this._logger.storeLogArray('Error', 'ERROR posting an object : ' + e);
                return observableThrowError(e);
            }));
    }

    public deleteObject(path: string): Observable<Object> {
        this._logger.info('ApiService', 'Deleting an object at: ' + path);
       // this._logger.storeLogArray('Info', 'Deleting an object at: ' + path);
        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/' + path;

        return this._http.delete(url).pipe(
            catchError(e => {
                this._logger.error('ApiService', 'ERROR deleting an object : ' + e);
                this._logger.storeLogArray('Error', 'ERROR deleting an object : ' + e);
                return observableThrowError(e);
            }));
    }

    public action(path: string, actionData: Object): Observable<Object> {
        this._logger.info('ApiService', 'Executing an action at: ' + path + ' ' + (actionData ? actionData['actionName'] : 'no data'));
        this._logger.storeLogArray('Info', 'Executing an action at: ' + path + ' ' + (actionData ? actionData['actionName'] : 'no data'));
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        let url = this._protocol + '//' + this._storage.getHost() + this._baseApi + '/' + path + '/ACTION';

        return this._http.put(url, JSON.stringify(actionData), {  headers }).pipe(
            catchError(e => {
                this._logger.error('ApiService', 'ERROR executing an action : \n' + e);
                this._logger.storeLogArray('Error', 'ERROR executing an action : \n' + e);
                return observableThrowError(e);
            }));
    }


public getErrorCode(error: any): string {
  if (error) {
    if (error instanceof HttpErrorResponse) {
      try {
        const body: any = error.error;
        if (body && (body.code === 'CMISERR_0' || body.code === 'CMISERR_1')) {
          return body.code;
        }
      } catch (e) {
        return 'UNKNOWN';
      }
    }
  }
  return 'UNKNOWN';
}


    public retriveFreeNumberRange(): Observable<Object>{

               let url = this._protocol + '//' + this._storage.getHost() + this._baseApi+'/Node/11/System_Parameters/1/Free_Directory_Number?attributes=Number';
                return this._http.get(url).pipe(
                    map(response => response),
                    catchError(e => {
                        return observableOf();
                    }),);
            }

}
